import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApplicationOfferBundleData, ApplicationOfferDisclosure } from 'common';
import { OfferBundleService } from '../shared/offer-bundle.service';
import { OfferService } from '../shared/offer.service';

@Injectable({
  providedIn: 'root'
})
export class OfferBundleResolver implements Resolve<ApplicationOfferBundleData> {

  constructor(
    private offerBundleService: OfferBundleService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApplicationOfferBundleData> {
      // A rejected resolve cancels the navigation, so a status without an offer bundle would never
      // reach its message screen. Resolve to null instead and let the component decide what to show.
      return this.offerBundleService.getByApplicationUUID(route.queryParams.uuid, route.queryParams.bundleId)
        .pipe(catchError(() => of(null)));
  }
}

@Injectable({
  providedIn: 'root'
})
export class OfferDisclosureResolver implements Resolve<ApplicationOfferDisclosure[]> {

  constructor(
    private offerService: OfferService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApplicationOfferDisclosure[]> {
      return this.offerService.getDisclosures(route.queryParams.uuid, route.queryParams.offerId);
  }
}
